import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
const STORAGE_KEY = 'cosmos_countdown_target_v3';
const DEFAULT_DURATION_MS = 14 * 60 * 60 * 1000 + 24 * 60 * 1000; // 14h 24m
function getTargetTime(): number {
  if (typeof window === 'undefined') return Date.now() + DEFAULT_DURATION_MS;
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = parseInt(stored, 10);
      if (!isNaN(parsed) && parsed > Date.now()) return parsed;
    }
    const target = Date.now() + DEFAULT_DURATION_MS;
    window.localStorage.setItem(STORAGE_KEY, String(target));
    return target;
  } catch {
    return Date.now() + DEFAULT_DURATION_MS;
  }
}
function getTimeLeft(target: number) {
  const diff = Math.max(0, target - Date.now());
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor(diff / (1000 * 60 * 60) % 24);
  const minutes = Math.floor(diff / (1000 * 60) % 60);
  const seconds = Math.floor(diff / 1000 % 60);
  return {
    days,
    hours,
    minutes,
    seconds,
    total: diff
  };
}
type Unit = {
  value: number;
  label: string;
};
function Digit({
  value
}: {
  value: number;
}) {
  const padded = String(value).padStart(2, '0');
  return <div className="relative flex items-center justify-center overflow-hidden h-12 md:h-14 w-full" data-id="element-234" data-mp="17t2kkpjt03x1">
      <AnimatePresence mode="popLayout" initial={false} data-id="element-235" data-mp="12tzpnxxjfe2s">
        <motion.span key={padded} initial={{
        y: '60%',
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: '-60%',
        opacity: 0
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="absolute font-heading font-black text-3xl md:text-4xl text-primary leading-none tracking-tight drop-shadow-[0_0_15px_rgba(212,168,87,0.35)]" data-id="element-236" data-mp="f3dhm6nj9tss">
          {padded}
        </motion.span>
      </AnimatePresence>
    </div>;
}
export function Countdown() {
  const [target] = useState<number>(() => getTargetTime());
  const [time, setTime] = useState(() => getTimeLeft(target));
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(getTimeLeft(target));
    }, 1000);
    return () => clearInterval(interval);
  }, [target]);
  const units: Unit[] = [{
    value: time.days,
    label: 'Días'
  }, {
    value: time.hours,
    label: 'Horas'
  }, {
    value: time.minutes,
    label: 'Minutos'
  }, {
    value: time.seconds,
    label: 'Segundos'
  }];
  return <div className="w-full max-w-xl mx-auto" data-id="element-237" data-mp="iea9lvfdcbyr">
      {/* Top text */}
      <div className="text-center mb-5" data-id="element-238" data-mp="n7lmad6v3myl">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary/8 border border-primary/30 backdrop-blur-sm" data-id="element-239" data-mp="n8oauegppdbc">
          <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary animate-pulse" aria-hidden="true" data-id="element-240" data-mp="3qv54anm0iq1r"></span>
          <p className="text-xs md:text-sm font-medium text-primary/95 tracking-wide" data-id="element-241" data-mp="3jbcni7lhflcx">
            Acceso con precio promocional disponible por tiempo limitado
          </p>
        </div>
      </div>

      {/* Countdown boxes */}
      <div className="grid grid-cols-4 gap-2 md:gap-3" data-id="element-242" data-mp="35ccyuzxyz6gr">
        {units.map((unit, i) => <div key={unit.label} className="relative flex flex-col items-center justify-center p-3 md:p-4 rounded-xl bg-card/60 border border-primary/20 backdrop-blur-sm shadow-[0_0_20px_rgba(212,168,87,0.08)]" data-id="element-243" data-mp="35ephzgfgrmve" data-mpi={i}>
            <Digit value={unit.value} data-id="element-244" data-mp="2qoi5dhc50y2m" />
            <span className="mt-1 text-[10px] md:text-xs uppercase tracking-[0.2em] text-muted-foreground/80 font-medium" data-id="element-245" data-mp="2qldrfs8venyr">
              {unit.label}
            </span>
            {i < units.length - 1 && <span className="hidden md:block absolute -right-2 top-1/2 -translate-y-1/2 text-primary/30 font-heading font-bold text-xl select-none" aria-hidden="true" data-id="element-246" data-mp="2homtfaarcz1j">
                :
              </span>}
          </div>)}
      </div>
    </div>;
}